import React, { FC } from 'react';

import { Typography } from 'Modules/ui3';


export interface NewsTagProps {
    tag: string;
}
export const NewsTag: FC<NewsTagProps> = ({ tag }) => (
    <Typography
        component='div'
        bgcolor='grayscale.shade0'
        border='1px solid'
        borderColor='grayscale.shade80'
        borderRadius={2}
        py={1}
        px={3}
        variant='regularBody2'
        lineHeight='1.5'
        color='grayscale.shade95'
        noWrap
        overflow='hidden'
        textOverflow='ellipsis'
        title={tag}
    >
        {tag}
    </Typography>
);
